import React, { useEffect, useState } from 'react';
import api from '../lib/api';
import CornerPanel from '../components/CornerPanel';
import RefreshButton from '../components/RefreshButton';
import { cstDateTime } from '../lib/time';
import { CheckCheck, AlertTriangle } from 'lucide-react';
import { toast } from 'sonner';

export default function Alerts() {
  const [alerts, setAlerts] = useState([]);
  const [unread, setUnread] = useState(0);
  const [last, setLast] = useState(null);

  const load = async () => {
    const { data } = await api.get('/alerts?limit=100');
    setAlerts(data.alerts || []);
    setUnread(data.unread || 0);
    setLast(new Date().toISOString());
  };
  useEffect(() => { load(); const iv = setInterval(load, 20000); return () => clearInterval(iv); }, []);

  const markRead = async () => {
    await api.post('/alerts/mark-read');
    toast.success('All alerts marked read');
    load();
  };

  return (
    <div className="p-4">
      <CornerPanel
        title={`Alerts Panel // ${unread} unread`}
        right={
          <div className="flex items-center gap-2">
            <RefreshButton onRefresh={load} lastUpdated={last} testId="alerts-refresh" />
            <button
              data-testid="alerts-mark-read"
              onClick={markRead}
              className="flex items-center gap-1 text-[11px] font-display tracking-[0.25em] uppercase border border-cyan-sys text-cyan-sys hover:bg-cyan-sys hover:text-black px-2 py-1"
            >
              <CheckCheck size={12} /> mark all
            </button>
          </div>
        }
        testId="alerts-panel"
      >
        {alerts.length === 0 ? (
          <div className="text-[var(--txt-muted)] py-6 text-center">// no alerts yet. run discovery scan to generate A+ setups.</div>
        ) : (
          <div className="divide-y divide-[var(--border-default)]">
            {alerts.map((a) => (
              <div key={a.id} className="py-2 flex items-center gap-3" data-testid={`alert-row-${a.symbol}`}>
                <AlertTriangle size={14} className={a.severity === 'high' ? 'text-sell' : 'text-hold'} />
                <div className="flex-1 min-w-0">
                  <div className="font-mono text-[13px] truncate">{a.message}</div>
                  <div className="text-[10px] text-[var(--txt-secondary)] uppercase tracking-wider mt-0.5">
                    {a.type} · {cstDateTime(a.timestamp)}
                  </div>
                </div>
                {!a.read && <span className="text-[9px] px-2 py-0.5 border border-cyan-sys text-cyan-sys tracking-widest">NEW</span>}
              </div>
            ))}
          </div>
        )}
      </CornerPanel>
    </div>
  );
}
